import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BreadCrumbs from "./../../components/BreadCrumbs/BreadCrumbs";
import OrderServices from "../../apis/Order/OrderServices";
//* Required Components
import {
  ErrorToaster,
  SuccessToaster,
} from "./../../components/Toaster/Toaster";
import colors from "../../styles/colors";
import { getTimeDate } from "../../utils/DateFormate";
import { Loading } from "./../../components/UI/Loader";
//* MUI Imports
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Recommend,
  RequestQuote,
  Done,
  Visibility,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  CloudUpload,
} from "@mui/icons-material";
import {
  Paper,
  Box,
  Grid,
  Typography,
  tooltipClasses,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  IconButton,
  Button,DialogTitle, 
  Dialog,DialogContent
} from "@mui/material";
import Papa from 'papaparse';
import useAuth from "../../hooks/useAuth";
import moment from "moment";
import { PrimaryButton, SecondaryButton } from "../../components/Button/Button";
import UserDocDialog from "../../components/Dialog/UserDocDialog";
import ProfileServices from "../../apis/Profile/ProfileServices";
import { useForm } from "react-hook-form";
//* Firebase import


//* Table Pagination ActionsComponent
function TablePaginationActions(props) {
  const theme = useTheme;

  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}


const tableHead = [
  "Order ID",
  "Date",
  "Customer Name",
  "Payment Mode",
  "Payment Amount",
  "Status",
  "Action",
];
// {
//   "customer_name": "test",
//   "customer_address": "test",
//   "customer_phone": "42345235",
//   "pickup_address": "test2",
//   "pickup_google_address": "Burj Khalifa - Dubai - United Arab Emirates",
//   "pickup_latitude": 25.1972295,
//   "pickup_longitude": 55.279747,
//   "google_map_location": "427 Mubarak Bin Mohammed St - Al Manhal - W13 02 - Abu Dhabi - United Arab Emirates",
//   "latitude": 24.4659143,
//   "longitude": 54.3578533,
//   "payment_mode": "Cash",
//   "payment_amount": "100",
//   "order_details": "no"
// }
async function getLatLngFromGoogle(url) {
  try {
    const encoded = encodeURIComponent(url);
    const apiKey = 'AIzaSyCsT-b8-J4wnqKYUBFROMPQr_IEYdjNiSg'

    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encoded}&key=${apiKey}`
    );

    const data = await response.json();

    if (data.status === "OK") {
      const loc = data.results[0].geometry.location;
      return {
        lat: loc.lat,
        lng: loc.lng
      };
    } else {
      return { lat: "", lng: "" };
    }
  } catch (error) {
    console.log("Google API Error:", error);
    return { lat: "", lng: "" };
  }
}

function BulkDialog({ open, onClose ,getOrders }) {
  const [fileSelected, setFileSelected] = useState(null);
  const [finalDatas, setFinalDatas] = useState([]);

  const { register, formState: { errors } } = useForm();

  const uploadFile = async () => {
    try {
      if (fileSelected) {
        const formData = new FormData();
        formData.append("csvFile", fileSelected);
        console.log(fileSelected ,"ssdsdsdsd")
        const { data, message } = await OrderServices.createPharmacyBulk({orders:finalDatas});

        if (!data) return;

        SuccessToaster(message);
        setFileSelected(null);
        getOrders()
        onClose();
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ textAlign: "center" }}>Upload Bulk Order</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            padding: 2,
          }}
        >
          <input
            id="uploadBulk"
            type="file"
            style={{ display: "none" }}
            {...register("file", { required: "Please upload file" })}
            onChange={(e) => {
              const file = e.target.files[0];
              setFileSelected(file);
            
              if (!file) return;
            
              Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: async function (results) {
                  const extracted = results.data;
              
                  const finalData = await Promise.all(
                    extracted.map(async (row) => {
                      const pickup = await getLatLngFromGoogle(row["Pickup Map Address"]);
                      const delivery = await getLatLngFromGoogle(row["Delivery Map Location"]);
              
                      return {
                        customer_name: row["Customer Name"],
                        customer_address: row["Delivery Address"],
                        customer_phone: row["Customer Phone"],
              
                        pickup_address: row["Pickup Address"],
                        pickup_google_address: (pickup?.lat || pickup?.lng) ?  (row["Pickup Map Address" || "Pickup Map Address Link"]) :null,
                        pickup_latitude: pickup.lat,
                        pickup_longitude: pickup.lng,
              
                        google_map_location: (delivery?.lat || delivery?.lng) ? (row["Delivery Map Location"] || row["Delivery Map Location Link"]) : null,
                        latitude: delivery.lat,
                        longitude: delivery.lng,
              
                        payment_mode: row["Payment Mode"],
                        payment_amount: row["Payment Amount"],
                        order_details: row["Order Detail"],
                        customer_map_link: (delivery?.lat ||  delivery?.lng) ? null : (row["Delivery Map Location"] || row["Delivery Map Location Link"]),
                        pickup_map_link: (pickup?.lat ||  pickup?.lng) ? null : (row["Pickup Map Address"] || row["Delivery Map Address Link"])
                      };
                    })
                  );
              setFinalDatas(finalData)
                  console.log("Final Mapped Data:", finalData);
                },
              });
              
            }}
            
          />
          <label htmlFor="uploadBulk" style={{ cursor: "pointer" }}>
            <CloudUpload
              sx={{
                fontSize: "80px",
                color: colors.primary,
                "&:hover": {
                  color: colors.secondary,
                  transition: "0.3s ease-in-out",
                },
              }}
            />
          </label>

          {fileSelected && (
            <Typography
              variant="body1"
              sx={{
                marginTop: 1,
                fontWeight: "bold",
                wordBreak: "break-word",
              }}
            >
              Selected File: {fileSelected.name}
            </Typography>
          )}

          {fileSelected && (
            <PrimaryButton title="Upload" onClick={uploadFile} />
          )}

          {errors.file && (
            <Typography color="error" variant="body2">
              {errors.file.message}
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

const PharmacyOrders = () => {
  const navigate = useNavigate();
  const { pharmacyId } = useAuth();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState("");
  const [rowsData, setRowsData] = useState([]);
  const [documents, setDocuments] = useState();
  const [docDialog, setDocDialog] = useState(false);
  const [open, setOpen] = useState(false);

  // *For Loader
  const [loader, setLoader] = useState(true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getOrders(newPage + 1, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 2));
    setRowsPerPage(Math.floor(event.target.value));
    setPage(0);
    getOrders(1, event.target.value);
  };

  //* All Orders API Call
  const getOrders = async (newPage, rowsPerPage) => {
    setLoader(true);
    const parms = {
          page :newPage ? newPage : 1,
       limit :  rowsPerPage ? rowsPerPage : "",
    }
    try {
      const { data } = await ProfileServices.PharmacyOrderList(
        parms
      );
      if (data === null) return;
      setRowsData(data.orders);
      setCount(data.count);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  const handleViewDoc = (doc) => {
    try {
      setDocuments(doc);
      setDocDialog(true);
    } catch (error) {
      console.log("file: Order.js:127 => handleViewDoc => error:", error);
    }
  };

  useEffect(() => {
    getOrders();
  }, []);

  return (
    <Fragment>
      <UserDocDialog
        open={docDialog}
        onClose={() => setDocDialog(false)}
        action={documents}
      />
      <Box
        sx={{
          backgroundColor: colors.lightGray,
          p: 3,
          borderRadius: "12px",
          // width: "calc(100vw - 370px)",
        }}
      >
        <Grid
          container
          sx={{
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={12} display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              color="primary"
              sx={{ borderRadius: "8px", textTransform: "none",mr:2 }}
              onClick={() => {
                const link = document.createElement("a");
                link.href = "/phamaexcel.csv"; // path to your Excel file in public folder
                link.download = "template.csv";    // filename for download
                link.click();
              }}
            >
              Download Template
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{ borderRadius: "8px", textTransform: "none",mr:2 }}
              onClick={() => setOpen(true)}
            >
              Upload Bulk Order
            </Button>
      <BulkDialog open={open} onClose={() => setOpen(false)} getOrders={getOrders} />

            <Button
              variant="contained"
              color="primary"
              sx={{ borderRadius: "8px", textTransform: "none" }}
              onClick={() => navigate("/create-order")}
            >
              Create Pharmacy Order
            </Button>
          </Grid>
        </Grid>

        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            bgcolor: colors.white,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Pharmacy Orders List
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Pharmacy Orders"]} />
          </Grid>
        </Grid>
        {loader ? (
          <Box sx={{ width: 1, textAlign: "center", pt: 5 }}>
            <Loading />
          </Box>
        ) : (
          <Fragment>
            <TableContainer
              component={Paper}
              sx={{
                "&::-webkit-scrollbar": {
                  bgcolor: colors.white,
                  height: "8px",
                  borderRadius: "10px",
                  cursor: "pointer",
                },
                "&::-webkit-scrollbar-thumb": {
                  bgcolor: colors.primary,
                  borderRadius: "10px",
                  cursor: "pointer",
                },
                "&.MuiPaper-root": {
                  borderRadius: "12px",
                  mt: 2,
                  boxShadow: 0,
                },
              }}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow sx={{ bgcolor: colors.lightGray }}>
                    {tableHead.map((item, index) => (
                      <TableCell key={index} sx={{ fontWeight: "bold" }}>
                        {item}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowsData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row?.order_id || "N/A"}</TableCell>
                      <TableCell component="th" scope="row">
                        {moment(row?.date).format("DD/MM/YYYY hh:mm a")}
                      </TableCell>
                      <TableCell>{row?.customer_name}</TableCell>
                      <TableCell>{row?.payment_mode}</TableCell>
                      <TableCell>{row?.payment_amount}</TableCell>
                      <TableCell>{row?.status}</TableCell>

                      <TableCell>
                        <Tooltip title="View">
                          <IconButton
                            onClick={() =>
                              navigate("/pharmacy-orders-detail", {
                                state: row,
                              })
                            }
                          >
                            <Visibility sx={{ color: colors.completed }} />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Table sx={{ marginTop: "12px" }}>
              <TablePagination
                sx={{
                  borderBottom: "none",
                  bgcolor: colors.white,
                  borderRadius: "12px",
                }}
                rowsPerPageOptions={[10, 20, 30]}
                colSpan={12}
                count={+count}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    "aria-label": "rows per page",
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Table>
          </Fragment>
        )}
      </Box>
    </Fragment>
  );
};

export default PharmacyOrders;
